import { User } from '@/components/auth/AuthProvider';

export const getUserDataHeaders = (user: User | null, orderCode: string | null) => ({
  ...(user && {
    'x-infopank-user-sso-id': user.profileId,
    'x-infopank-user-email': user.email,
  }),
  ...(orderCode && { 'x-infopank-user-telmos-order-id': orderCode }),
});
